import { gql } from '@apollo/client'

// This is the same for public and resigned public profiles
export default gql`
  fragment Citizenship on Citizenship {
    country
    displayOrder
  }
`
